export const SET_CURRENT_USER = "SET_CURRENT_USER";
export const LOADING = "LOADING";
export const GET_ERRORS = "GET_ERRORS";
export const CLEAR_ERRORS = "CLEAR_ERRORS";
export const INIT_CONNECTION = "INIT_CONNECTION";
export const PRESCRIPTION_LOADING = "PRESCRIPTION_LOADING";
export const GET_PRESCRIPTIONS = "GET_PRESCRIPTIONS";
export const GET_PRESCRIPTIONS_BY_ID = "GET_PRESCRIPTIONS_BY_ID";
export const GET_PRESCRIPTION_BY_NUMBER = "GET_PRESCRIPTION_BY_NUMBER";
export const GET_PRESCRIPTION_BY_STATUS = "GET_PRESCRIPTION_BY_STATUS";
export const GET_DRAFT = "GET_DRAFT";
export const GET_PENDING = "GET_PENDING";
export const GET_USERS = "GET_USERS";
export const GET_PRESCRIPTION_HISTORY = "GET_PRESCRIPTION_HISTORY";
export const DISPENSED_NOTIFICTION = "DISPENSED_NOTIFICTION";
export const PRESCRIPTION_ARRIVED = "PRESCRIPTION_ARRIVED";
export const GET_USER_BY_ID = "GET_USER_BY_ID";
export const SUCCESS_MESSAGE = "SUCCESS_MESSAGE";
export const RESET_PWD_SUCCESS = "RESET_PWD_SUCCESS";
export const NOT_ACTIVE = "NOT_ACTIVE";
export const NEW_MESSAGE = "NEW_MESSAGE";

export const GET_DRAFTED = "GET_DRAFTED";
export const GET_PENDINGS = "GET_PENDINGS";
export const GET_APPROVED = "GET_APPROVED";

export const INITIAL_LOAD = "INITIAL_LOAD";
export const UPDATE_DATA = "UPDATE_DATA";

export const OPEN_CHAT = "OPEN_CHAT";

export const APPROVE_PRESCRIPTION_LOADING = "OPEN_CHAT";
export const GET_APPROVE_PRESCRIPTIONS = "GET_APPROVE_PRESCRIPTIONS";

export const DISPENSE_PRESCRIPTION_LOADING = "DISPENSE_PRESCRIPTION_LOADING";
export const GET_DISPENSED_PRESCRIPTIONS = "GET_DISPENSED_PRESCRIPTIONS";

export const Draft_prescription_view = "Draft_prescription_view";

export const GET_DURINFO = "GET_DURINFO";
export const MODAL_PRESCRIPTION_VIEW = "MODAL_PRESCRIPTION_VIEW";

export const START_VIDEO_CALL = "START_VIDEO_CALL";
export const OPEN_STORE_MODAL = "OPEN_STORE_MODAL";
export const START_COUNSEL_CALL = "START_COUNSEL_CALL";
export const COUNSELLING_PRESCRIPTION_ARRIVED = "COUNSELLING_PRESCRIPTION_ARRIVED";
